module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/arrow_white-61c1577f788db8721a0b7015ac2219e2.svg";